<template>
    <div class="grid">
        <div class="col-12">
            <div class="p-fluid">
                <div class="field grid">
                    <label for="name4" class="col-12 mb-2 md:col-2 md:mb-0">{{ $t('salary') }}</label>
                    <div class="col-12 md:col-5">
                        <InputNumber id="salary" mode="decimal" locale="id-ID" v-model="form.salary" :class="{'p-invalid' : submitted && !form.salary }"/>
                        <small class="p-invalid" v-if="submitted && !form.salary"
                            >{{ $t('salary') }} is required.</small
                        >
                    </div>
                </div>
                <div class="field grid">
                    <label for="name4" class="col-12 mb-2 md:col-2 md:mb-0">{{ $t('fixed-allowance') }}</label>
                    <div class="col-12 md:col-5">
                        <InputNumber id="salary" mode="decimal" locale="id-ID" v-model="form.fixed_allowance"/>
                    </div>
                </div>
                <div class="field grid">
                    <label for="name4" class="col-12 mb-2 md:col-2 md:mb-0">{{ $t('transport-allowance') }}</label>
                    <div class="col-12 md:col-5">
                        <InputNumber id="salary" mode="decimal" locale="id-ID" v-model="form.transport_allowance"/>
                    </div>
                </div>
                <div class="field grid">
                    <label for="name4" class="col-12 mb-2 md:col-2 md:mb-0">{{ $t('functional-allowance') }}</label>
                    <div class="col-12 md:col-5">
                        <InputNumber id="salary" mode="decimal" locale="id-ID" v-model="form.functional_allowance"/>
                    </div>
                </div>
                <div class="field grid">
                    <label for="name4" class="col-12 mb-2 md:col-2 md:mb-0">{{ $t('meal-allowance') }}</label>
                    <div class="col-12 md:col-5">
                        <InputNumber id="salary" mode="decimal" locale="id-ID" v-model="form.meal_allowance"/>
                    </div>
                </div>
                <div class="field grid">
                    <label for="name4" class="col-12 mb-2 md:col-2 md:mb-0">{{ $t('special-allowance') }}</label>
                    <div class="col-12 md:col-5">
                        <InputNumber id="salary" mode="decimal" locale="id-ID" v-model="form.special_allowance"/>
                    </div>
                </div>
                <div class="field grid">
                    <label for="name4" class="col-12 mb-2 md:col-2 md:mb-0">{{ $t('communication-allowance') }}</label>
                    <div class="col-12 md:col-5">
                        <InputNumber id="salary" mode="decimal" locale="id-ID" v-model="form.communication_allowance"/>
                    </div>
                </div>
                <div class="field grid">
                    <label for="name4" class="col-12 mb-2 md:col-2 md:mb-0">TOTAL</label>
                    <div class="col-12 md:col-5">
                        {{ totalIncome }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Button from 'primevue/button';
import Calendar from 'primevue/calendar';
import Dropdown from 'primevue/dropdown';
import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';
export default{
    components:{
        Button, Calendar, Dropdown, InputText, InputNumber,
    },
    props: ['model'],
    data(){
        return{
            form: this.$page.props.employee.salary ?? [],
        }
    },
    computed: {
        totalIncome(){
            return this.calculateIncome();
        },
    },
    mounted(){
        this.calculateIncome();
    },
    methods:{
        calculateIncome(){
            let income = this.form;
            let netIncome = 0;

            income.salary = !isNaN(parseInt(income.salary)) ? parseInt(income.salary) : 0 ;
            income.fixed_allowance = !isNaN(parseInt(income.fixed_allowance))  ? parseInt(income.fixed_allowance) : 0;
            income.transport_allowance = !isNaN(parseInt(income.transport_allowance)) ? parseInt(income.transport_allowance) : 0;
            income.functional_allowance = !isNaN(parseInt(income.functional_allowance)) ? parseInt(income.functional_allowance) : 0;
            income.meal_allowance = !isNaN(parseInt(income.meal_allowance)) ? parseInt(income.meal_allowance) : 0;
            income.special_allowance = !isNaN(parseInt(income.special_allowance)) ? parseInt(income.special_allowance) : 0;
            income.communication_allowance = !isNaN(parseInt(income.communication_allowance)) ? parseInt(income.communication_allowance) : 0;

            netIncome = income.salary + income.fixed_allowance + income.fixed_allowance +
                        income.transport_allowance + income.functional_allowance + income.meal_allowance +
                        income.special_allowance + income.communication_allowance;

            return netIncome.toLocaleString('id-ID');
        }
    }
}
</script>
